import resizeSensor from "element-resize-detector";
import { debounce } from "kinnect-helpers";

export default {
	name: "KAutoScroll",

	props: {
		scrollTarget: String,

		delay: {
			default: 5000,
			type: Number
		},

		duration: {
			default: 25000,
			type: Number
		}
	},

	data: () => ( {
		height: 0,
		scrollHeight: 0,
		isScrolling: false,
		resizeSensor: null
	} ),

	computed: {
		scrollDistance() {
			return this.scrollHeight - this.height;
		},

		scrollEnabled() {
			return this.scrollDistance > 0;
		}
	},

	watch: {
		scrollEnabled: {
			handler( val ) {
				if ( val ) {
					this.startScrolling();
				}
			},
			immediate: true
		}
	},

	methods: {
		getEl() {
			return this.scrollTarget
				? this.$el.querySelector( this.scrollTarget )
				: this.$el;
		},

		doScroll( direction ) {
			return new Promise( ( resolve, reject ) => {
				if ( this.scrollEnabled ) {
					this.$vuetify.goTo(
						direction === "down" ? this.scrollDistance : 0,
						{
							appOffset: false,
							container: this.getEl(),
							duration: this.duration,
							easing: "linear"
						}
					)
					.then( resolve );
				} else {
					reject();
				}
			} );
		},

		scrollDown() {
			return this.doScroll( "down" );
		},

		scrollUp() {
			return this.doScroll( "up" );
		},

		delayScroll() {
			const now = Date.now();
			const syncInterval = this.delay;
			const timeToNextInterval = ( Math.ceil( now / syncInterval ) * syncInterval ) - now;

			return new Promise( resolve => setTimeout(
				resolve,
				this.delay + timeToNextInterval
			) );
		},

		startScrolling() {
			if ( !this.isScrolling && this.scrollEnabled ) {
				this.isScrolling = true;

				this.delayScroll()
				.then( this.scrollDown )
				.then( this.delayScroll )
				.then( this.scrollUp )
				.then( () => {
					this.isScrolling = false;

					this.startScrolling();
				} );
			}
		},

		monitorSizes() {
			const targetEl = this.getEl();

			this.resizeSensor = resizeSensor( { strategy: "scroll" } );
			this.resizeSensor.listenTo(
				targetEl,
				debounce( () => {
					this.height = targetEl ? targetEl.offsetHeight : 0;
					this.scrollHeight = targetEl ? targetEl.scrollHeight : 0;
				}, 300 )
			);
		},

		unmonitorSizes() {
			this.resizeSensor.uninstall( this.getEl() );

			this.resizeSensor = null;
		}
	},

	mounted() {
		this.monitorSizes();
	},

	beforeDestroy() {
		this.unmonitorSizes();
	},

	render() {
		return this.$slots.default;
	}
};
